import image4 from '../../assests/images/Image 4.png';
import image5 from '../../assests/images/Image 5.png';
import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import styles from './TokenExpiry.module.css';

const TokenExpiry = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  useEffect(() => {
    const performLogout = async () => {
      try {
        localStorage.removeItem('menuName');
        const allCookies = cookies.getAll();

        for (const cookieName in allCookies) {
          cookies.remove(cookieName, { path: '/' });
        }
        setTimeout(() => {
          navigate('/');
        }, 4000);
      } catch (error) {
        console.error('Error during logout:', error);
      }
    };

    performLogout();
  }, []);
  return (
    <div className={styles.main}>
      <div className={styles.leftBg}>
        <img src={image4} alt="background" />
      </div>
      <div className={styles.rightBg}>
        <img src={image5} alt="background" />
      </div>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <h3 className={styles.welcomeText}>Token Expiry</h3>
          <p className={styles.message}>The token has expired. Please log in again to continue using the website.</p>
          <p className={styles.thanks}>Thanks!</p>
        </div>
      </div>
    </div>
  );
};

export default TokenExpiry;
